<template lang="html">
  <v-list two-line avatar>
    <v-list-item v-for="(client, index) in clients" :key="index"
    @click="$emit('selectIndex', index)"
    :style="selected_index === index? 'background-color: #616161':''">
      <v-list-item-avatar color="grey">
        <span class="white--text pl-2">{{ getClientToken(client) }}</span>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ client.name }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <StandardDeleteButton @clickDelete="$emit('removeClient', { client_id: client.id })" />
      </v-list-item-action>

    </v-list-item>
    <slot name="add-client" />
  </v-list>
</template>
<script>
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'
export default {
  props: ['clients', 'selected_index'],
  components: { StandardDeleteButton },
  methods: {
    getClientToken(client){
      if (client.name[0] && client.name[1]) {
        return client.name[0].toUpperCase() + client.name[1].toUpperCase();
      }
      if (client.name[0]) {
        return client.name[0].toUpperCase()
      }
      return 'C';
    }
  }
}
</script>
<style>

</style>
